export default __webpack_public_path__ + "static/media/back_arrow.bc1cc4c8.svg";